import React from "react";
import "./CaretIcon.css";

export default function CaretIcon({ direction = "down" }) {
  return <span className={`CaretIcon ${direction}`}></span>;
}
